import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils";

export const VerifiedBadge = ({ className }: { className?: string }) => {
  return (
    <div className={cx("flex items-center gap-1 mt-1", className)}>
      <div className="bg-primary-500 p-[2px] rounded-full">
        <HugeiconsIcon
          icon={Tick02Icon}
          strokeWidth={3}
          size={10}
          className="text-white"
        />
      </div>
      <p className="text-primary-600 font-medium text-xs">Verified</p>
    </div>
  );
};
